// extracted by mini-css-extract-plugin
export default {"wrapper":"ShippersSkeleton_wrapper__MCAI5","lines-container":"ShippersSkeleton_lines-container__auu6Q"};